import { sentenceCase } from '@/lib/text'

/** Words a notice type keeps in capitals when the rest of it is put into sentence case. */
const ACRONYMS = new Set(['AGM', 'SGM', 'EGM', 'IPO', 'FPO', 'NRB', 'SEBON', 'NEPSE'])

/**
 * A notice type as a badge reads: sentence case. `type` is free text, and
 * legacy rows are often SHOUTED ("RIGHT SHARE"), so an all-capitals label is
 * lowered, keeping the acronyms. A label with any lower-case letter was typed
 * as it should read and is left alone.
 */
export const typeLabel = (type: string): string => {
  const text = type.trim()
  return text === text.toUpperCase() ? sentenceCase(text, ACRONYMS) : text
}
